// @flow

import React, { PureComponent } from 'react';
import { dynamicClassName } from '../../utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  pages: Array<{ number: number, url: string }>,
  currentPage: number,
  lastPage: number
};

class Pagination extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    pages: [
      {
        number: 1,
        url: '#'
      }
    ],
    currentPage: 1,
    lastPage: 99
  };

  renderItem = (): any => {
    const { pages, currentPage } = this.props;

    return pages.map((page, index) => {
      return (
        <li key={index}>
          {/* @apsulis ATTENTION si la page est la page active PAS DE LIEN, mais un span, il n'y a aucun sens à avoir un lien vers soit-même */}
          {/* TODO : changer le lien sur active quand on aura la bonne inté */}
          {currentPage === page.number ? (
            <Link title={`Se rendre à la page ${page.number}`} to={page.url} className="is-active">
              {page.number}
            </Link>
          ) : (
            <Link title={`Se rendre à la page ${page.number}`} to={page.url}>
              {page.number}
            </Link>
          )}
        </li>
      );
    });
  };

  render() {
    const { currentPage, lastPage } = this.props;
    const classNamesPrev = dynamicClassName('pagination__prev');
    const classNamesNext = dynamicClassName('pagination__next');
    currentPage === 1 && classNamesPrev.add('is-disabled');
    lastPage === currentPage && classNamesNext.add('is-disabled');

    return (
      <ul className="pagination">
        <li className={classNamesPrev.build()}>
          <Link title="Se rendre à la page de résultat précédente" to="#">
            <i className="icon icon-chevron-left" />
          </Link>
        </li>
        {this.renderItem()}
        <li className={classNamesNext.build()}>
          <Link title="Se rendre à la page de résultat suivante" to="#">
            <i className="icon icon-chevron-right" />
          </Link>
        </li>
      </ul>
    );
  }
}

export default Pagination;
